document.addEventListener('DOMContentLoaded', initWishlist);
document.addEventListener('shopify:section:load', initWishlist); // For dynamic sections
  const notificationWrapper = document.getElementById("wishlist-notification-wrapper");
  const notificationList = document.getElementById("wishlist-notification-list");
  
// Main initialization function
function initWishlist() {
  const wishlist = getWishlist();
  updateWishlistUI(wishlist);
  
  // Handle wishlist page rendering
  if (document.getElementById('wishlist-items-container')) {
    renderWishlistPage();
  }

  // Event delegation for all wishlist buttons
  document.body.addEventListener('click', handleWishlistClick);
}

// Improved click handler
async function handleWishlistClick(e) {
  const btn = e.target.closest('.wishlist-button, .wishlist-remove-btn');
  if (!btn) return;

  e.preventDefault();
  const handle = btn.dataset.handle || btn.dataset.productHandle;
  const updatedWishlist = toggleWishlistItem(handle);
  
  // Update button state
  btn.classList.toggle('active', updatedWishlist.includes(handle));
  
  // Special handling for wishlist page
  if (btn.classList.contains('wishlist-remove-btn')) {
    setTimeout(() => renderWishlistPage(), 300);
  }
  
  // Update UI
  updateWishlistUI(updatedWishlist);

  // Show notification if item was added
if (updatedWishlist.includes(handle)) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (res.ok) {
      const product = await res.json();
      showProductNotification(product); 
    }
  } catch (err) {
    console.error('Error fetching product for notification:', err);
  }
}
}

async function renderWishlistPage() {
  const container = document.getElementById('wishlist-items-container');
  if (!container) return;

  let wishlist = getCleanWishlist();
  container.innerHTML = '<p>Loading your wishlist...</p>';

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="empty-wishlist-content">
        <h2>YOUR FAVORITES LIST IS EMPTY</h2>
        <p>Your favorites list allows you to keep track of all your favorite items. Just tap the heart icon, and all your favorites will be saved. You don't need to waste time looking for the things you loved – everything is gathered here in one place!</p>
        <a href="/collections" class="button">Continue shopping</a>
      </div>
    `;
    return;
  }

  let html = '';
  const validHandles = [];

  for (const handle of wishlist) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (res.ok) {
        const product = await res.json();
        validHandles.push(handle);
        const formattedPrice = formatMoney(product.price);

        // Pastikan gambar
        let imageUrl = product.featured_image || 
                       (product.images && product.images.length > 0 ? product.images[0] : '');
        if (imageUrl) {
          if (imageUrl.startsWith('//')) imageUrl = 'https:' + imageUrl;
          if (!imageUrl.includes('?')) imageUrl += '?v=1&width=533';
        } else {
          imageUrl = 'https://via.placeholder.com/533x533/f5f5f5/cccccc?text=No+Image';
        }

        const isProductInWishlist = getWishlist().includes(handle);

        html += `
<li class="grid__item">
  <div class="card-wrapper underline-links-hover">
    <div class="card card--standard card--media" style="height: 100%;">
      <!-- Tombol Wishlist -->
      <div class="product-card-wishlist">
        <button class="wishlist-button ${isProductInWishlist ? 'active' : ''}" 
                data-product-handle="${product.handle}" 
                style="background: none; border: none; padding: 0; cursor: pointer; z-index: 30;">
          <svg class="heart-icon" viewBox="0 0 24 24" fill="${isProductInWishlist ? 'red' : 'none'}" stroke="currentColor" stroke-width="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        </button>
      </div>
      <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125.0%">
        <div class="card__media" style="position: relative; width: 100%; aspect-ratio: 1; overflow: hidden; background: #f5f5f5;">
          <a href="/products/${product.handle}" class="product-link">
            <img 
              src="${imageUrl}"
              alt="${product.title}"
              style="width: 100%; height: 100%; object-fit: cover; object-position: center; display: block;"
              loading="lazy"
              onerror="this.src='https://via.placeholder.com/533x533/f5f5f5/cccccc?text=No+Image'">
          </a>
        </div>
      </div>
      <!-- Product info -->
      <div class="card__content" style="padding: 0.2rem 0 0 0;">
        <div class="card__information">
          <h3 class="card__heading" style="margin: 0; font-size: 2rem; font-weight: 500;">
            <a href="/products/${product.handle}" class="full-unstyled-link" style="text-decoration: none; color: #000;">
              ${product.title}
            </a>
          </h3>
          <div class="card-information">
            <div class="price" style="color: #000; font-size: 1.6rem; font-weight: 500;">
              <div class="price__container">
                <span class="price-item price-item--regular">${formattedPrice}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</li>`;
      }
    } catch (err) {
      console.error(`Error loading product ${handle}:`, err);
    }
  }


  updateLocalStorage(validHandles);


  container.innerHTML = html || '<div class="wishlist-empty">Your wishlist is empty</div>';
}

function updateLocalStorage(validHandles) {
  localStorage.setItem('wishlist', JSON.stringify(validHandles));
}


function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  } catch {
    return [];
  }
}

function getCleanWishlist() {
  return getWishlist().filter(handle => handle && typeof handle === 'string');
}

function toggleWishlistItem(handle) {
  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  
  if (index === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(index, 1);
  }
  
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  return wishlist;
}

// UI updates
function updateWishlistUI(wishlist) {
  const count = wishlist.length;
  updateWishlistCounter(count);
  updateAllWishlistButtons(wishlist);
}

function updateWishlistCounter(count) {
  let badge = document.querySelector('.wishlist-count');
  const link = document.querySelector('.header-wishlist-link');
  
  if (!badge && link) {
    badge = document.createElement('span');
    badge.className = 'wishlist-count';
    link.appendChild(badge);
  }
  
  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }
}

function updateAllWishlistButtons(wishlist) {
  document.querySelectorAll('.wishlist-button').forEach(btn => {
    const handle = btn.dataset.productHandle;
    btn.classList.toggle('active', wishlist.includes(handle));
  });
}

// Notification system
async function showProductNotification(handle) {
function showProductNotification(product) {
  if (!product) return;
  
  const notification = document.createElement('div');
  notification.className = 'wishlist-notification';
  notification.innerHTML = `
    <div class="wishlist-notification-content">
      <img src="${product.featured_image}" alt="${product.title}">
      <p>Added to wishlist: ${product.title}</p>
    </div>
  `;
  
  document.body.appendChild(notification);
  setTimeout(() => notification.classList.add('show'), 10);
  setTimeout(() => {
    notification.classList.remove('show');
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}
}

// Utility function
function formatMoney(cents) {
  const amount = cents / 100;
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    currencyDisplay: 'symbol', 
  });
  
 
  const formattedAmount = formatter.format(amount);
  

  return formattedAmount.replace('Rp', '').trim() + '';
}
